import React, { Component } from 'react'

import EnquireNowButton from '../EnquireNowButton'

import {
  ResponsiveContainer,
  Description,
  Container,
  Heading,
  MobileHeading
} from './styledComponents'

export default class LandingSection extends Component {
  render() {
    const {
      landingSectionData: { heading, description, mobileHeading },
      formData,
      glsLoaded
    } = this.props
    return (
      <Container>
        <ResponsiveContainer>
          <Heading dangerouslySetInnerHTML={{ __html: heading }} />
          <MobileHeading>{mobileHeading}</MobileHeading>
          <Description>{description}</Description>
          <EnquireNowButton
            id={'experimental-marketing-landing-section-enquire-button'}
            formData={formData}
            glsLoaded={glsLoaded}
            text="ENQUIRE NOW"
          />
        </ResponsiveContainer>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/LandingSection/index.js